
<svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <!-- Generator: Sketch 50.2 (55047) - http://www.bohemiancoding.com/sketch -->
    <desc>Created with Sketch.</desc>
    <defs></defs>
    <g id="Stockholm-icons-/-Files-/-Pictures2" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <rect id="bound" x="0" y="0" width="24" height="24"></rect>
        <path d="M3.5,21 L20.5,21 C21.3284271,21 22,20.3284271 22,19.5 L22,8.5 C22,7.67157288 21.3284271,7 20.5,7 L10,7 L7.43933983,4.43933983 C7.15803526,4.15803526 6.77650439,4 6.37867966,4 L3.5,4 C2.67157288,4 2,4.67157288 2,5.5 L2,19.5 C2,20.3284271 2.67157288,21 3.5,21 Z" id="Combined-Shape" fill="#000000" opacity="0.3"></path>
        <circle id="Oval-32" fill="#000000" opacity="0.3" cx="13.5" cy="16.5" r="2.5"></circle>
        <circle id="Oval-32-Copy" fill="#000000" opacity="0.3" cx="10.5" cy="16.5" r="2.5"></circle>
        <circle id="Oval-32-Copy-2" fill="#000000" opacity="0.3" cx="9.5" cy="13.5" r="2.5"></circle>
        <circle id="Oval-32-Copy-3" fill="#000000" opacity="0.3" cx="14.5" cy="13.5" r="2.5"></circle>
        <circle id="Oval-32-Copy-4" fill="#000000" opacity="0.3" cx="12" cy="11.5" r="2.5"></circle>
    </g>
</svg>
